<app-loading></app-loading>
<router-outlet></router-outlet>
<app-floating-contact *ngIf="showFloating"></app-floating-contact>